export default __webpack_public_path__ + "static/media/ss-boat.3acfcb34.jpg";